import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SourceGuardIcon extends BaseIcon {
  getChildren = () => {
    return [
      <g>
        <path fill={ this.getColor() }
              d="M47.62,18a11.84,11.84,0,0,0-7.16-4.54,13.74,13.74,0,0,0-26.84-2.67,13.55,13.55,0,0,0-1.43-.08A12.14,12.14,0,0,0,11.42,35v0h28a10.38,10.38,0,0,0,8.23-17Z"/>
        <path fill={ '#fff' } d="M28.53,11.3a1,1,0,0,0-.93.65l-7,18.8a1,1,0,0,0,1.88.7l7-18.8a1,1,0,0,0-.59-1.29A1,1,0,0,0,28.53,11.3Z"/>
        <path fill={ '#fff' } d="M39.84,22.26l-9.13,4.67a1,1,0,0,0,.45,1.89,1,1,0,0,0,.46-.11L42,23.38Z"/>
        <path fill={ '#fff' } d="M43.14,22.7a1.07,1.07,0,0,1-.46-.11l-12-6.12a1,1,0,1,1,.91-1.78l12,6.12a1,1,0,0,1-.45,1.89Z"/>
        <path fill={ '#fff' } d="M10.16,21.14l9.13-4.67a1,1,0,0,0-.45-1.89,1,1,0,0,0-.46.11L8,20Z"/>
        <path fill={ '#fff' } d="M6.86,20.7a1.07,1.07,0,0,1,.46.11l12,6.12a1,1,0,1,1-.91,1.78l-12-6.12a1,1,0,0,1,.45-1.89Z"/>
      </g>
    ]
  }
  getViewBox = () => '0 0 50 36'
}
